import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { Lock } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="py-24 relative overflow-hidden bg-[#0a0f1a]" data-id="element-112">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-green-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-113" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-114">
        <FadeIn data-id="element-115">
          <div className="bg-[#111827] border-2 border-cyan-500/30 rounded-3xl p-8 md:p-16 text-center shadow-[0_0_50px_rgba(6,182,212,0.1)]" data-id="element-116">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-117">
              Recuperar tu tiempo no debería costarte lo que ganas en un día de
              trabajo.
            </h2>

            <p className="text-xl text-[#d1d5db] mb-10" data-id="element-118">
              Por eso, el acceso completo al{' '}
              <span className="text-white font-semibold" data-id="element-119">
                Manual del Empleado Invisible
              </span>{' '}
              tiene un precio único de lanzamiento.
            </p>

            <div className="mb-10" data-id="element-120">
              <span className="text-slate-400 line-through text-2xl mr-4" data-id="element-121">
                $97 USD
              </span>
              <div className="inline-block" data-id="element-122">
                <span className="text-6xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-cyan-400" data-id="element-123">
                  $6.36
                </span>
                <span className="text-xl text-slate-400 ml-2 font-bold" data-id="element-124">
                  USD
                </span>
              </div>
            </div>

            <div className="flex justify-center mb-8" data-id="element-125">
              <CTAButton className="w-full md:w-auto md:min-w-[400px]" href="https://www.flujoeficiente.com/cart/51642214678848:1" data-id="element-126" />
            </div>

            <div className="flex items-center justify-center gap-2 text-slate-400 text-sm" data-id="element-127">
              <Lock className="w-4 h-4 text-green-400" data-id="element-128" />
              <span data-id="element-129">
                Acceso instantáneo después del pago. Pago 100% seguro y
                encriptado.
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}